

















































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "@/lib/util";
import AbpBase from "@/lib/abpbase";
import PageRequest from "@/store/entities/page-request";
import PageCard from "@/components/page-card.vue";
import Author from "@/store/entities/author";
class AuthorsPageRequest extends PageRequest {
  keyword: string;
}
class MediaPageRequest extends PageRequest {
  keyword: string;
  type: string;
}

@Component({
  components: { PageCard },
})
export default class Authors extends AbpBase {
  //filters
  pagerequest: AuthorsPageRequest = new AuthorsPageRequest();
  mediaPageRequest: MediaPageRequest = new MediaPageRequest();
  get list() {
    return this.$store.state.authors.list;
  }
  get loading() {
    return this.$store.state.authors.loading;
  }
  create() {
    const authorId = "0";
    this.$router.push({ name: "author", params: { authorId } });
  }
  async edit(row) {
    const authorId = row.id;
    this.$router.push({ name: "author", params: { authorId } });
  }
  pageChange(page: number) {
    this.$store.commit("authors/setCurrentPage", page);
    this.getpage();
  }
  pagesizeChange(pagesize: number) {
    this.$store.commit("authors/setPageSize", pagesize);
    this.getpage();
  }
  async getpage() {
    this.pagerequest.maxResultCount = this.pageSize;
    this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
    await this.$store.dispatch({
      type: "authors/getAll",
      data: this.pagerequest,
    });
  }
  async search() {
    this.$store.commit("authors/setCurrentPage", 1);
    this.getpage();
  }
  get pageSize() {
    return this.$store.state.authors.pageSize;
  }
  get totalCount() {
    return this.$store.state.authors.totalCount;
  }
  get currentPage() {
    return this.$store.state.authors.currentPage;
  }
  columns = [
    {
      title: this.L("Name"),
      key: "name",
    },
    {
      title: this.L("Surname"),
      key: "surname",
      wdith: 80,
    },
    {
      title: this.L("Actions"),
      key: "Actions",
      width: 120,
      render: (h: any, params: any) => {
        return h("ButtonGroup", [
          h("Button", {
            props: {
              type: "primary",
              size: "small",
              icon: "md-create",
            },
            style: {
              // marginRight:'5px'
            },
            on: {
              click: () => {
                this.edit(params.row);
              },
            },
          }),
          h("Button", {
            props: {
              type: "error",
              icon: "md-trash",
              size: "small",
            },
            on: {
              click: async () => {
                this.$Modal.confirm({
                  title: this.L("Tips"),
                  content: this.L("DeleteMediaConfirm"),
                  okText: this.L("Yes"),
                  cancelText: this.L("No"),
                  onOk: async () => {
                    await this.$store.dispatch({
                      type: "authors/delete",
                      data: params.row,
                    });
                    await this.getpage();
                  },
                });
              },
            },
          }),
        ]);
      },
    },
  ];
  async created() {
    this.getpage();
  }
}
